<template>
  <div></div>
</template>

<script>
export default {
  name: 'tooltipScreeningCatalogueAnalysis'
}
</script>
